module.exports = __webpack_public_path__ + "static/media/krx-trading-tut-02.d655545f.jpg";